import { GallerySceneType } from '../CommonTypes';
import useGalleryScenes from '../hooks/useGalleryScenes';

export const PanoramaSceneSelect = ({
  currentScene,
  setSelectedScene,
}: {
  currentScene: GallerySceneType;
  setSelectedScene: (view: GallerySceneType) => void;
}) => {
  const [galleryScenes] = useGalleryScenes('cube');

  return (
    <div className="z-2 absolute left-0 top-40 flex -translate-y-1/2 flex-col gap-2">
      {galleryScenes.map((scene, index) => {
        const isActive = currentScene?.sceneid === scene.sceneid;
        return (
          <button
            key={`scene-button-${index}`}
            onClick={() => setSelectedScene(scene)}
            className={`rounded-r-md px-4 py-2 text-sm text-white transition hover:scale-105 ${
              isActive ? 'scale-105 bg-[#00965f]/80 font-bold shadow-lg' : 'bg-black bg-opacity-50'
            }`}
          >
            {scene.name ?? `Scen ${index + 1}`}
          </button>
        );
      })}
    </div>
  );
};
